export const stateClasses = {
  // UNATTEMPTED: "step",
  ATTEMPTED: "attempted",
  ONGOING: "step-pickup",
  COMPLETED: "step-completed",
  SUCCESS: "step-success",
  FAILED: "step-order-failed",
  PREVIOUS_FAILED: "sml-failed",
  PREVIOUS_SUCCESS: "sml-success-step",
};

export const identifierClasses = {
  STEP: ".step",
  TITLE: ".title",
  DATE: ".date-text",
  CIRCLE: ".count-circle",
  UPDATES_ALL: ".allupdate-wrapper",
  INFO: ".info",
  LOADER: ".loader",
  REASONING: ".reasoning",
};

export const identifierIds = {
  MAP: "#map-container",
  ORDER_ID: "#order-id-text",
  ESTIMATED_DATE: "#Estimated-Date-Text",
  ESTIMATED_TIME: "#Estimated-Time-Text",
  ORDER_STATE: "#order-state-text",
  RIDER_ASSIGNED: "#step-assigned",
  DELIVERY: "#step-delivered",
  PICKUP: "#step-pickup",
  PREVIOUS_RIDER_ASSIGN: "#previous-step-assigned",
  PREVIOUS_PICKUP: "#previous-step-pickup",
  PREVIOUS_DELIVERY: "#previous-step-delivery",
  PREVIOUS_ATTEMPT: "#previous-attempt-failed",
  WRAPPER: "#main-wrapper",
  ORDER_FAILED_DATE: "#order-failed-date",
  ORDER_FAILED_DATE_PICKUP: "#order-failed-date-pickup",
  RETURN: "#step-return",
  CONSIGNEE_DATA: "#consignee-data",
  PREVIOUS_ATTEMPT_FAILED_PICKUP: "#previous-attempt-failed-pickup",
  CONSIGNEE_NAME: "#consignee-name",
  CONSIGNEE_NUMBER: "#consignee-number",
  SHIPMENTS_MODAL: "#modal-wrapper",
};

export const orderStates = {
  "created:created": "Your order will be picked soon",
  "inProgress:scheduled": "Your order will be picked soon",
  "inProgress:assigned": "Your order will be picked up today",
  "inProgress:active": "Your order is arriving today",
  "closed:success": "Your order has been delivered successfully",
  "executed:success": "Your order has been delivered successfully",
  "executed:delivered": "Your order has been delivered successfully",
  "closed:failed": "Order not delivered",
  "executed:failed": "Order not delivered",
  "executed:undelivered": "Order not delivered",
  onhold: "Your order has been put on hold",
  "closed:closed": "Your order is completed",
  "inProgress:rescheduled": "Your order will be re-attempted",
};

export const orderStatesReverse = {
  "created:created": "Your return order will be picked soon",
  "inProgress:scheduled": "Your return order will be picked soon",
  "inProgress:assigned": "Your return order will be picked up today",
  "inProgress:active": "Your return order has been picked up",
  "closed:success": "Your return order has been received",
  "executed:success": "Your return order has been received",
  "executed:delivered": "Your return order has been received",
  "closed:failed": "Your return order failed",
  "executed:failed": "Your return order failed",
  "executed:undelivered": "Your return order failed",
  onhold: "Your order has been put on hold",
  "closed:closed": "Your order is completed",
  "inProgress:rescheduled": "Your order will be re-attempted",
};
